export const START_CHAT_CRM = 'START_CHAT_SDK';
export const START_CHAT_CRM_JM = 'START_CHAT_SDK_JM';
export const END_CHAT_CRM = 'END_CHAT_SDK';
export const INITIALIZE_CHAT_TOKEN = 'INITIALIZE_CHAT_TOKEN';
export const END_CHAT_TOKEN = 'END_CHAT_TOKEN';
